import {Component, signal, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {SelectionPossibilities, ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {Render} from "@cm/template-nodes"
import type {RenderParameters} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-render-inspector",
    templateUrl: "./render-inspector.component.html",
    styleUrl: "./render-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class RenderInspectorComponent extends BaseInspectorComponent<Render> {
    readonly $tilingPossibilities = signal<SelectionPossibilities<RenderParameters["renderTiling"]>>([
        {value: "auto", name: "Auto"},
        {value: "on", name: "On"},
        {value: "off", name: "Off"},
    ])
    readonly $textureStreamingPossibilities = signal<SelectionPossibilities<boolean | undefined>>([
        {value: undefined, name: "Default"},
        {value: true, name: "On"},
        {value: false, name: "Off"},
    ])
}
